import { Button } from "@component/button";
import { SettingsIcon, UserPlusIcon } from "lucide-react";
import { useState } from "react";
import { Tabs, TabsContent, } from "@component/tabs";
import InviteFriendDialog from "./dialog/invite-friend";
import PaymentSettingsDialog from "./dialog/payment-setting";
import CandidateListReferral from "./candidate-list-referral";
import CandidateListPayroll from "./candidate-list-payroll";


export default function CandidateMyPayment() {
    const [isOpenModalPaymentSetting, setOpenModalPaymentSetting] = useState<boolean>(false);
    const [isOpenModalInviteFriend, setOpenModalInviteFriend] = useState<boolean>(false);
    const [activeTab, setActiveTab] = useState<string>("referrals");

    return (
        <>
            <div className="mx-auto">
                <div className="space-y-4">
                    <div className="flex flex-col sm:flex-row space-y-3 sm:space-y-0 justify-between sm:items-center mb-0 sm:mb-6">
                        <div>
                            <h1 className="text-2xl font-bold text-black">My Payments</h1>
                            <p className="text-gray-600">
                                View and manage your payment information.
                            </p>
                        </div>
                        <div className="flex space-x-2">
                            <Button
                                onClick={() => setOpenModalInviteFriend(true)}
                                className="text-sm bg-white hover:bg-blue-600 hover:text-white hover:border-blue-600 transition-colors"
                                variant="outline"
                            >
                                <UserPlusIcon className="h-4 w-4" />
                                Invite Friends
                            </Button>
                            <Button
                                variant="outline"
                                className="text-sm bg-white hover:bg-blue-600 hover:text-white hover:border-blue-600 transition-colors"
                                onClick={() => setOpenModalPaymentSetting(true)}
                            >
                                <SettingsIcon className="h-4 w-4" />
                                Payment Settings
                            </Button>
                        </div>
                    </div>
                </div>

                <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
                    {/* <TabsList className="grid w-full grid-cols-2">
                        {tabs.map((tab) => (
                            <TabsTrigger key={tab.id} value={tab.id}>
                                <tab.icon className="h-4 w-4 mr-2" />
                                {tab.label}
                            </TabsTrigger>
                        ))}
                    </TabsList> */}
                    <TabsContent value="payroll" className="space-y-4">
                        <div className="mt-6">
                            <h2 className="text-lg font-medium mb-4">Your Payrolls</h2>
                            <CandidateListPayroll
                                onShowModalPaymentSetting={() => setOpenModalPaymentSetting(true)}
                            />
                        </div>
                    </TabsContent>
                    <TabsContent value="referrals" className="space-y-4">
                        <div className="mt-6">
                            <h2 className="text-lg font-medium mb-4">Your Referrals</h2>
                            <CandidateListReferral />
                        </div>
                    </TabsContent>
                </Tabs>
            </div>

            <InviteFriendDialog
                isOpen={isOpenModalInviteFriend}
                onClose={() => setOpenModalInviteFriend(false)}
            />

            <PaymentSettingsDialog
                isOpen={isOpenModalPaymentSetting}
                onClose={() => setOpenModalPaymentSetting(false)}
            />
        </>
    )
}